import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

const CustomerTrendsCards = () => {
  return (
    <Row className="">
      <Col lg={3} md={6} sm={12} xs={12}>
        <Card
          className="w-100 info-card"
          style={{ border: "0.1px solid #FD754533", borderRadius: "10px" }}
        >
          <CardBody className="d-flex justify-content-between align-items-start my-1 info-block">
            <div>
              <div className="info-title">{"This Month Usage"}</div>
              <div className="info-color-value" style={{ color: "#FF7A45" }}>
                {"23.5 GB"}
              </div>
            </div>
            <div
              className="info-icon"
              style={{ background: "#FD75451A", borderRadius: "10px" }}
            >
              <i
                className="mdi mdi-trending-up"
                style={{ color: "#FF7A45", fontSize: "20px" }}
              ></i>
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col lg={3} md={6} sm={12} xs={12}>
        <Card
          className="w-100 info-card"
          style={{ border: "0.1px solid #FD754533", borderRadius: "10px" }}
        >
          <CardBody className="d-flex justify-content-between align-items-start my-1 info-block">
            <div>
              <div className="info-title">{"Average Daily Usage"}</div>
              <div className="info-color-value" style={{ color: "#06B6D4" }}>
                {"780 MB"}
              </div>
            </div>
            <div
              className="info-icon"
              style={{ background: "#06B6D41A", borderRadius: "10px" }}
            >
              <i
                className="mdi mdi-trending-down"
                style={{ color: "#06B6D4", fontSize: "20px" }}
              ></i>
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col lg={3} md={6} sm={12} xs={12}>
        <Card
          className="w-100 info-card"
          style={{ border: "0.1px solid #FD754533", borderRadius: "10px" }}
        >
          <CardBody className="d-flex justify-content-between align-items-start my-1 info-block">
            <div>
              <div className="info-title">{"Days Remaining"}</div>
              <div className="info-color-value" style={{ color: "#8B5CF6" }}>
                {"18 days"}
              </div>
            </div>
            <div
              className="info-icon"
              style={{ background: "#8B5CF61A", borderRadius: "10px" }}
            >
              <i
                className="ri-calendar-line"
                style={{ color: "#8B5CF6", fontSize: "20px" }}
              ></i>
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col lg={3} md={6} sm={12} xs={12}>
        <Card
          className="w-100 info-card"
          style={{ border: "0.1px solid #FD754533", borderRadius: "10px" }}
        >
          <CardBody className="d-flex justify-content-between align-items-start my-1 info-block">
            <div>
              <div className="info-title">{"Current Bill"}</div>
              <div className="info-color-value" style={{ color: "#10B981" }}>
                {"$49.99"}
              </div>
            </div>
            <div
              className="info-icon"
              style={{ background: "#10B9811A", borderRadius: "10px" }}
            >
              <i
                className="bx bx-dollar"
                style={{ color: "#10B981", fontSize: "20px" }}
              ></i>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default CustomerTrendsCards;
